import { render, staticRenderFns } from "./AddNewSizeModal.vue?vue&type=template&id=01193889&scoped=true&"
import script from "./AddNewSizeModal.vue?vue&type=script&lang=js&"
export * from "./AddNewSizeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01193889",
  null
  
)

export default component.exports